import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SettingsStyle.css"

interface Props{
    token: string;
    accountStatus: string;
    testAlarms: number;
}

const Settings = ({token,accountStatus,testAlarms}:Props) => {

    
    const navigate = useNavigate();
        

    const onAboExtendClick = () => {
        navigate("/PayPage")
      }

    const isExpired = () => {
        if(accountStatus == "Test"){
          return true
        } else{
          const today = new Date(); // Aktuelles Datum
          const expirationDate = new Date(accountStatus); // accountStatus als Datum
  
          // Einen Tag in Millisekunden
          const oneDay = 24 * 60 * 60 * 1000;
  
          // Überprüfen, ob das Ablaufdatum kleiner oder gleich einem Tag nach heute ist
          return expirationDate.getTime() <= today.getTime() + oneDay;
        }
          
    };

    return <div className="mainContainer">
        <div className="titleContainer">
            <h2>Junior Alarm Einstellungen</h2>
        </div>
        <br />
        <div className="inputContainer">
        <button className="settings-button" onClick={() => navigate("/MainPage")}>Zurück</button>
        </div>

        <div className="inputContainer">
        <label>App-Token: {token}</label><br />
          {accountStatus === "Test" ? (
                <label>Mögliche Testalarme: {testAlarms}</label>
            ) : (
                <label>Das Abo läuft ab am: {accountStatus === "Payed" ? "Niemals" : accountStatus}</label>
            )}
          {accountStatus !== "Payed" && isExpired() && (
                <p style={{ color: 'red' }}>Achtung: Das Abo läuft bald ab!</p>
          )}
          {accountStatus !== "Payed" && isExpired() && (
                <div className="inputContainer">
                <input
                className="inputButton"
                type="button"
                onClick={onAboExtendClick}
                value={"Abo verlängern"} />
            </div>
          )}
          <br /><button className="logout-button" onClick={() => navigate("/ChangePassword")}>Passwort ändern</button>
  
          <br /><button className="unit-button" onClick={() => navigate("/UnitsSettings")}>Einheiten</button>
          
        </div>
    </div>
}

export default Settings
